import $ from 'jquery';
import { component as defineComponent } from 'flightjs';
import withAsyncForm from 'launch/modules/mixins/with-async-form';

function AutoSaver() {
    var timer = null;

    this.attributes({
        saveTimeout: 1000,
        method: 'post',
        step: null,
        action: null,
    });

    this.activateAutoSave = function () {
        this.deactivateAutoSave();

        timer = setTimeout(
            $.proxy(function () {
                this.submitForm([
                    {
                        name: 'step',
                        value: this.attr.step,
                    },
                ]);
            }, this),
            this.attr.saveTimeout
        );
    };

    this.deactivateAutoSave = function () {
        clearTimeout(timer);
        timer = null;
    };

    this.after('ajaxProcessing', function () {
        this.trigger('autosaveProcessing');
    });

    this.after('ajaxSuccess', function () {
        this.trigger('autosaveSuccess');
    });

    this.after('initialize', function () {
        this.on('formChanged', this.activateAutoSave);

        this.on('autosaveDeactivateRequested', this.deactivateAutoSave);
    });
}

export default defineComponent(withAsyncForm, AutoSaver);



// WEBPACK FOOTER //
// ./src/web/js/launch/modules/auto-saver.js